import { render, staticRenderFns } from "./PDFRead.vue?vue&type=template&id=3a25b2d8&scoped=true&"
import script from "./PDFRead.vue?vue&type=script&lang=js&"
export * from "./PDFRead.vue?vue&type=script&lang=js&"
import style0 from "./PDFRead.vue?vue&type=style&index=0&id=3a25b2d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a25b2d8",
  null
  
)

export default component.exports